import { Component, OnInit } from '@angular/core';
import { FavieTranslateService } from 'src/shared/translate/servives/favie-translate.service';
import { Router } from '@angular/router';
import { PopoverService } from '../popover/popover.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public locale;
  public displayLanguageSecondaryMenu = false;
  public languages;

  constructor(
    private readonly translationService: FavieTranslateService,
    private readonly router: Router,
    private popoverService: PopoverService
  ) {}

  ngOnInit(): void {
    this.locale = this.translationService.getLanguage();
    this.languages = [
      { value: 'en', label: 'English' },
      { value: 'fr', label: 'Français' },
    ];
  }

  changeLanguage(language) {
    this.translationService.switchLanguage(language);
    this.locale = language;
  }

  goHome() {
    this.router.navigate(['']);
  }

  handlePhone(phone: string) {
    this.popoverService.setState(true);
    document.location.href = 'tel:' + phone;
  }

  handleEmail(email: string) {
    this.popoverService.setState(true);
    document.location.href = email;
  }
}
